module.exports = __webpack_public_path__ + "img/treasuries.2f267c4e.svg";